export function getStartOfDay(date: Date): Date {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  return startOfDay;
}

export function getEndOfDay(date: Date): Date {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
}

export function matchesDateRange(
  uploadDateValue: number | null,
  startTime: number | null,
  endTime: number | null,
): boolean {
  if (!startTime && !endTime) {
    return true;
  }

  if (!uploadDateValue) {
    return false;
  }

  return (!startTime || uploadDateValue >= startTime) && (!endTime || uploadDateValue <= endTime);
}
